import { DataObject, DataProperty } from "../../_core/type-converter";
import { CommonModel } from "../model";

@DataObject()
export class AlertTypeModel extends CommonModel {
    public Category: string = null;
    public Enabled: boolean = null;
}